import React from 'react'
import styles from './shimmer.module.scss'

const Shimmer = () => (
  <div className={styles.shimmerContainer}>
    <div className={styles.shimmer}> </div>
  </div>
  )

export default Shimmer
